import ApiManager from '../Api.manager'
import HttpConstants from '../../constants/HttpConstants'
import UrlConstants from '../../constants/UrlConstants'

export const getStripeCustomerPortalUrl = (payload: {
  $id: string
  $organizationId: string
}) => {
  const usecase = UrlConstants.STRIPE_CUSTOMER_PORTAL_URL.USECASE
  return new Promise((resolve, reject) => {
    ApiManager.makeApiCallWithAuthentication(
      usecase,
      HttpConstants.GET_METHOD,
      payload
    )
      .then((response) => {
        if (response.status === 200) {
          resolve(response)
        } else {
          throw response
        }
      })
      .catch((error) => {
        reject(error)
      })
  })
}

export const getStripeInvoices = (payload: { $customerId: string }) => {
  const usecase = UrlConstants.STRIPE_INVOICES.USECASE
  return new Promise((resolve, reject) => {
    ApiManager.makeApiCallWithAuthentication(
      usecase,
      HttpConstants.GET_METHOD,
      payload
    )
      .then((response) => {
        if (response.status === 200) {
          resolve(response)
        } else {
          throw response
        }
      })
      .catch((error) => {
        reject(error)
      })
  })
}

export const getStripePlanDetails = (payload: {
  $stripePriceId: string
  $stripeProductId: string
  $subscriptionId: string
}) => {
  const usecase = UrlConstants.STRIPE_PLAN_DETAILS.USECASE
  return new Promise((resolve, reject) => {
    ApiManager.makeApiCallWithAuthentication(
      usecase,
      HttpConstants.GET_METHOD,
      payload
    )
      .then((response) => {
        if (response.status === 200) {
          resolve(response)
        } else {
          throw response
        }
      })
      .catch((error) => {
        reject(error)
      })
  })
}
